export default __webpack_public_path__ + "static/media/logo04.d4601325.svg";